import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect } from 'react';
import { IconEditCustom, IconDelete, IconPlusCircleOutline, IconLock } from '@sfx/icons';
import { TableView } from '../../../index';
import EditForm from './EditForm';

var CellActions = function CellActions(props) {
  var original = props.original,
      action = props.action;
  var handleEdit = action.handleEdit,
      handleDel = action.handleDel,
      canEdit = action.canEdit,
      canDel = action.canDel,
      readOnly = action.readOnly;

  var handleEditClick = function handleEditClick() {
    if (handleEdit) {
      handleEdit(original);
    }
  };

  var handleDelClick = function handleDelClick() {
    if (handleDel) {
      handleDel(original);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "table-icon-group"
  }, canEdit && /*#__PURE__*/React.createElement("span", {
    onClick: handleEditClick
  }, /*#__PURE__*/React.createElement(IconEditCustom, {
    size: 18
  })), canDel && /*#__PURE__*/React.createElement("span", {
    onClick: handleDelClick
  }, /*#__PURE__*/React.createElement(IconDelete, {
    size: 18
  })), readOnly && /*#__PURE__*/React.createElement(IconLock, {
    size: "18"
  }));
};

var EditTable = function EditTable(props) {
  var prefix = props.prefix,
      addButtonText = props.addButtonText,
      containerId = props.containerId,
      _props$tableData = props.tableData,
      tableData = _props$tableData === void 0 ? [] : _props$tableData,
      columns = props.columns,
      formItemList = props.formItemList,
      updateTableData = props.updateTableData,
      updateFormItemList = props.updateFormItemList,
      trans = props.trans;

  var _useState = useState('add'),
      _useState2 = _slicedToArray(_useState, 2),
      formType = _useState2[0],
      updateFormType = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      currentObject = _useState4[0],
      updateCurrentObject = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formVisible = _useState6[0],
      updateFormVisible = _useState6[1];

  var scrollToAnchor = function scrollToAnchor() {
    var anchorElement = document.getElementById(containerId);

    if (anchorElement) {
      anchorElement.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    }
  };

  var updateState = function updateState(_ref) {
    var currentObject = _ref.currentObject,
        formType = _ref.formType,
        _ref$visible = _ref.visible,
        visible = _ref$visible === void 0 ? true : _ref$visible;
    updateCurrentObject(_objectSpread({}, currentObject));
    formType && updateFormType(formType);
    updateFormVisible(visible);
  };

  var handleEdit = function handleEdit(original) {
    updateState({
      currentObject: original,
      formType: 'edit'
    });
    setTimeout(function () {
      scrollToAnchor();
    }, 100);
  };

  var handleDel = function handleDel(original) {
    var tableList = tableData.filter(function (i) {
      return i._id !== original._id;
    });
    updateTableData(tableList);
  };

  var handleAdd = function handleAdd() {
    var currentObject = {
      canEdit: true,
      canDel: true
    };
    updateState({
      currentObject: currentObject,
      formType: 'add'
    });
    setTimeout(function () {
      scrollToAnchor();
    }, 100);
  };

  var onCancel = function onCancel() {
    updateState({
      currentObject: {},
      visible: false
    });
  };

  var onSave = function onSave() {
    var data = _toConsumableArray(tableData);

    if (formType === 'add') {
      data.push(currentObject);
    } else {
      data = data.map(function (n) {
        return n._id === currentObject._id ? currentObject : n;
      });
    }

    data.forEach(function (n, i) {
      return n._id = i;
    });
    updateState({
      currentObject: {},
      visible: false
    });
    updateTableData(data);
  };

  var columnAction = {
    id: '_actions',
    Header: '',
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    headerStyle: {
      minWidth: 75
    },
    style: {
      minWidth: 75
    },
    minWidth: 75,
    className: 'disable-resize',
    headerClassName: 'disable-resize',
    Cell: function Cell(props) {
      var original = props.original;
      var action = {
        canEdit: original.canEdit,
        canDel: original.canDel,
        readOnly: original.readOnly,
        handleEdit: handleEdit,
        handleDel: handleDel
      };
      return /*#__PURE__*/React.createElement(CellActions, _extends({}, props, {
        prefix: prefix,
        action: action
      }));
    }
  };
  var columnsWithAction = [].concat(_toConsumableArray(columns), [columnAction]);
  useEffect(function () {
    if (updateFormItemList) {
      updateFormItemList(currentObject);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [currentObject]);
  return /*#__PURE__*/React.createElement("div", {
    id: containerId
  }, !!tableData.length && /*#__PURE__*/React.createElement(TableView, {
    className: "".concat(prefix, "-table"),
    data: tableData,
    columns: columnsWithAction,
    showPagination: false,
    getTrProps: function getTrProps(state, RowInfo) {
      var original = RowInfo.original;
      return {
        className: original._id === currentObject._id ? 'activeItem' : ''
      };
    }
  }), !formVisible && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-icon-wrap")
  }, /*#__PURE__*/React.createElement("span", {
    onClick: handleAdd
  }, /*#__PURE__*/React.createElement(IconPlusCircleOutline, {
    size: "18"
  }), "\xA0", addButtonText)), formVisible && /*#__PURE__*/React.createElement(EditForm, {
    formItemList: formItemList,
    prefix: prefix,
    disableSave: false,
    cancelButtonText: trans('SFxUserPreferencesTableCancelText'),
    saveButtonText: trans('SFxUserPreferencesTableSaveText'),
    onCancel: onCancel,
    onSave: onSave,
    currentObject: currentObject,
    updateCurrentObject: updateCurrentObject
  }));
};

export default EditTable;